import React, { useLayoutEffect, useRef, useState } from 'react'

import { cn } from '@/lib/utils'
import { formatSwapAmountDisplay } from '@/utils/swapAmountDisplay'

const MIN_FONT_PX = 14
const MAX_FONT_PX = 28

/** Monto con escala fluida (Opción A): reduce tamaño hasta caber en una línea. */
export function MobileFluidAmount({
  value,
  active,
  empty,
  onFocus,
  className,
  'aria-label': ariaLabel,
}: {
  value: string
  active?: boolean
  empty?: boolean
  onFocus: () => void
  className?: string
  'aria-label'?: string
}) {
  const containerRef = useRef<HTMLButtonElement>(null)
  const textRef = useRef<HTMLSpanElement>(null)
  const [fontSize, setFontSize] = useState(MAX_FONT_PX)
  const displayValue = formatSwapAmountDisplay(value) || '0'

  useLayoutEffect(() => {
    const container = containerRef.current
    const text = textRef.current
    if (!container || !text) return

    const caretReserve = active ? 6 : 0
    let size = MAX_FONT_PX
    text.style.fontSize = `${size}px`

    while (size > MIN_FONT_PX && text.scrollWidth + caretReserve > container.clientWidth) {
      size -= 1
      text.style.fontSize = `${size}px`
    }

    setFontSize(size)
  }, [displayValue, active])

  return (
    <button
      ref={containerRef}
      type="button"
      className={cn(
        'nm-mobile-simple__amount-fluid',
        active && 'nm-mobile-simple__amount-fluid--active',
        empty && 'nm-mobile-simple__amount-fluid--empty',
        className,
      )}
      onClick={onFocus}
      aria-label={ariaLabel}
    >
      <span
        className="nm-mobile-simple__amount-fluid-content"
        style={{ fontSize: `${fontSize}px` }}
      >
        <span ref={textRef} className="nm-mobile-simple__amount-fluid-text">
          {displayValue}
        </span>
        {active ? <span className="nm-mobile-simple__amount-fluid-caret" aria-hidden /> : null}
      </span>
    </button>
  )
}
